export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      required: true,
      default: '',
    },
  },
};
